import type { FetchResponse } from 'openapi-fetch';
import type { paths } from './coreApiSchema';
import type { SuccessResponse } from 'openapi-typescript-helpers';
import { API_VERSION } from '../config/app';
import { coreApiClient } from './apiClient';
import packageJson from '../../package.json';
import { getItem } from '../utils/storage';

export const updatePushToken = async (
  token: string
): Promise<
  FetchResponse<
    paths['/core/v1/push-tokens/{id}']['put'],
    SuccessResponse<paths['/core/v1/push-tokens/{id}']['put']['responses']>,
    'application/json'
  >
> => {
  const res = await coreApiClient.PUT('/core/v1/push-tokens/{id}', {
    params: {
      path: { id: token },
      header: {
        authorization: `Bearer ${getItem('coreApiAccessToken')}`,
        'cosafe-api-version': String(API_VERSION),
      },
    },
    body: { appVersion: packageJson.version, type: 'desktop' },
  });

  return res;
};

export const deletePushToken = async (
  token: string,
  userId?: number
): Promise<
  FetchResponse<
    paths['/core/v1/push-tokens/{id}']['delete'],
    SuccessResponse<paths['/core/v1/push-tokens/{id}']['delete']['responses']>,
    'application/json'
  >
> => {
  const res = await coreApiClient.DELETE('/core/v1/push-tokens/{id}', {
    params: {
      path: { id: token },
      header: {
        'cosafe-api-version': String(API_VERSION),
      },
      query: userId ? { userId } : undefined,
    },
  });

  return res;
};
